import {
  FormControl, InputLabel, MenuItem, SelectChangeEvent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../../components/CustomSelect';
import { useGetAccountPlanDefinitions } from '../../../../hooks/query/useAccounts';
import STRING_KEYS from '../../../../language/keys';
import { style } from './style';

type AccountPaidPlanSelectorProps = {
  pricePlan: string,
  viewMode: ViewMode,
  onValuesChange: (name: string, value: string) => void,
  isEditable: boolean,
}
export const AccountPaidPlanSelector = ({
  pricePlan,
  viewMode,
  isEditable,
  onValuesChange,
}: AccountPaidPlanSelectorProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const { data: planDefinitions = [] } = useGetAccountPlanDefinitions();

  const renderMenu = ():React.ReactNode => {
    return planDefinitions.map(({ pricingPlan, id, displayName }) => {
      return (
        <MenuItem
          key={ id }
          value={ pricingPlan }
        >
          {displayName}
        </MenuItem>
      );
    });
  };
  
  const selectAccountDefinitionId = (value: string) => {
    const accountDefenitionId = planDefinitions.find(
      ({ pricingPlan }) => pricingPlan === value);
    onValuesChange('accountPlanDefinitionId', accountDefenitionId?.id || '');
  };

  return (
    <FormControl
      fullWidth
      variant={ isEditable ? 'outlined' : 'standard' }
      margin="normal"
    >
      <InputLabel id="pricingPlan" sx={ style.label.sx }>
        {translate(STRING_KEYS.PRICING_PLAN)}
      </InputLabel>
      <CustomSelect
        labelId="pricingPlan"
        value={ pricePlan || '' }
        viewMode={ viewMode }
        name="pricingPlan"
        label={ translate(STRING_KEYS.PRICING_PLAN) }
        onChange={ (e:SelectChangeEvent<unknown>) => {
          onValuesChange('pricingPlan', e.target.value as string);
          selectAccountDefinitionId(e.target.value as string);
        } }
      >
        {renderMenu()}
      </CustomSelect>
    </FormControl>
  );
};
